import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'zc-help-text',
  templateUrl: './help-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpTextComponent {}
